export default "__VITE_ASSET__CIc747O8__"